import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TimelapseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"timelapse"}/>
}
